import * as React from "react";
import { PatientWithReportInfo } from "./PatientList";
import DoctorIcon from "../resources/images/patients/doctor-icon.svg";
import PracticeIcon from "../resources/images/patients/practice-icon.svg";
import "./AssignedToCell.scss";

interface AssignedToCellProps {
  patient: PatientWithReportInfo;
}

const AssignedToCell = ({ patient }: AssignedToCellProps) => {
  return (
    <div className="v-flex with-small-gap">
      <div className="h-flex no-wrap with-small-gap flex-center">
        <img src={DoctorIcon} alt="doctor icon" />
        {getNameOrNotAssigned(patient.attributes.doctorName)}
      </div>
      <div className="h-flex no-wrap with-small-gap flex-center">
        <img src={PracticeIcon} alt="practice icon" />
        {getNameOrNotAssigned(patient.attributes.practiceName)}
      </div>
    </div>
  );
};

function getNameOrNotAssigned(value): React.JSX.Element {
  let className = "";
  let text = value;
  if (value == null) {
    className = "patient-not-assigned";
    text = i18n["Page.Patient.Not.Assigned"];
  }
  return <span className={className}>{text}</span>;
}

export default AssignedToCell;
